module.exports = __webpack_public_path__ + "img/default-preview.74992a03.png";